import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

const DEFAULT = {
  settings: {
    business_name: "Accessible Trials & Mods",
    public_email: "admin@accessible.org.au",
    phone: "[Phone number]",
    service_area: "Melbourne and Victoria",
    hours: "Monday to Friday, 9:00am – 5:00pm",
  },
  content: { home: {}, funding: { sections: [] }, about: { values: [] }, faqs: { items: [] }, team: { items: [] }, testimonials: { items: [] }, gallery: { items: [] } },
};

const SiteCtx = createContext(DEFAULT);

export function SiteProvider({ children }) {
  const { data, isLoading } = useQuery({ queryKey: ["site"], queryFn: () => api.get("/public/site").then((r) => r.data) });
  const value = data
    ? { settings: { ...DEFAULT.settings, ...data.settings }, content: { ...DEFAULT.content, ...data.content }, loading: false }
    : { ...DEFAULT, loading: isLoading };
  return <SiteCtx.Provider value={value}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);

export const telHref = (phone) => (phone && /\d/.test(phone) ? `tel:${phone.replace(/[^\d+]/g, "")}` : null);
